import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../../images/logo/logo.jpg";
import insta from "../../images/instagram-icon.png";
import facebook from "../../images/facebook.png";

function Header() {
  const [isNavVisible, setNavVisible] = useState(false);

  const toggleNav = () => {
    setNavVisible(!isNavVisible);
  };

  return (
    <header className="header">
      <div className="header-container">
        <img src={logo} alt="Company Logo" className="logo" />
        <button className="menu-toggle" aria-label="Toggle Menu" onClick={toggleNav}>
          ☰
        </button>
        <nav className={`main-nav ${isNavVisible ? "visible" : ""}`}>
          <ul className="nav-list">
            <li>
              <Link to="/">Accueil</Link>
            </li>
            <li>
              <Link to="/services">Services</Link>
            </li>
            <li>
              <Link to="/galerie">Galerie</Link>
            </li>
            <li>
              <Link to="/contact">Contact</Link>
            </li>
            <li>
              <Link to="/FAQ">FAQ</Link>
            </li>
          </ul>
        </nav>
        <div className="media-icon">
          <Link to="https://www.facebook.com/share/15pB3cFWnd/">
            <img src={facebook} alt="Facebook Icon" className="instagram-icon" />
          </Link>
          <Link to="https://www.instagram.com/lpweppes/">
            <img src={insta} alt="Instagram Icon" className="instagram-icon" />
          </Link>
        </div>
      </div>
    </header>
  );
}

export default Header;
